
import React from 'react'
import {mdx} from '@mdx-js/react'

/* @jsxRuntime classic */
/* @jsx mdx */
/* @jsxFrag mdx.Fragment */
import withLayout from 'nextra-theme-mui-docs';
import {withSSG} from 'nextra/ssg';
import layoutConfig from '/vercel/path0/docs/theme.config.js';
import CodeExample from 'nextra-theme-mui-docs/CodeExample';
import Example from '../../examples/nextra-theme-mui-docs/Example';
import srcExample from '../../examples/nextra-theme-mui-docs/Example?raw';
const MDXLayout = function NextraPage(props) {
  return withSSG(withLayout({
    filename: "nextra-theme-mui-docs.mdx",
    route: "/more/nextra-theme-mui-docs",
    meta: {},
    pageMap: [{
      "name": "component-api",
      "children": [{
        "name": "DataFilter",
        "route": "/component-api/DataFilter"
      }, {
        "name": "DataGrid",
        "route": "/component-api/DataGrid"
      }, {
        "name": "Sparkbars",
        "route": "/component-api/Sparkbars"
      }, {
        "name": "Sparkline",
        "route": "/component-api/Sparkline"
      }],
      "route": "/component-api"
    }, {
      "name": "components",
      "children": [{
        "name": "DataFilter",
        "route": "/components/DataFilter",
        "frontMatter": {
          "title": "DataFilter"
        }
      }, {
        "name": "DataGrid",
        "children": [{
          "name": "columns",
          "route": "/components/DataGrid/columns",
          "frontMatter": {
            "title": "Columns"
          }
        }, {
          "name": "index",
          "route": "/components/DataGrid",
          "frontMatter": {
            "title": "Basic Usage",
            "description": "Lorem ipsum dolor sit amet.",
            "order": ["index"]
          }
        }, {
          "name": "virtualization",
          "route": "/components/DataGrid/virtualization",
          "frontMatter": {
            "title": "Virtualization",
            "description": "Lorem ipsum dolor sit amet."
          }
        }],
        "route": "/components/DataGrid"
      }, {
        "name": "SelectionList",
        "route": "/components/SelectionList",
        "frontMatter": {
          "title": "Introduction",
          "hidden": true
        }
      }, {
        "name": "Sparkbars",
        "route": "/components/Sparkbars",
        "frontMatter": {
          "title": "Sparkbars"
        }
      }, {
        "name": "Sparkline",
        "route": "/components/Sparkline",
        "frontMatter": {
          "title": "Sparkline"
        }
      }, {
        "name": "visx",
        "route": "/components/visx"
      }],
      "route": "/components"
    }, {
      "name": "index",
      "route": "/",
      "frontMatter": {
        "title": "Introduction",
        "order": ["index", {
          "name": "components",
          "title": "Components"
        }, {
          "name": "component-api",
          "title": "Component Api"
        }, {
          "name": "more",
          "title": "More"
        }]
      }
    }, {
      "name": "more",
      "children": [{
        "name": "markdown",
        "route": "/more/markdown",
        "frontMatter": {
          "hidden": true
        }
      }, {
        "name": "nextra-theme-mui-docs",
        "route": "/more/nextra-theme-mui-docs"
      }],
      "route": "/more"
    }]
  }, layoutConfig))(props);
};
function MDXContent({components, ...props}) {
  return <MDXLayout components={components} {...props}><h1>{"nextra-theme-mui-docs"}</h1><p><inlineCode parentName="p">{"nextra-theme-mui-docs"}</inlineCode>{" is a theme for "}<a href="https://nextra.vercel.app/" parentName="p">{"Nextra"}</a>{" that's built with the "}<a href="https://next.material-ui.com/" parentName="p">{"Material UI"}</a>{" library."}</p><h2>{"Installation"}</h2><pre><code parentName="pre">{"yarn create next-app --example https://github.com/Janpot/mui-plus/tree/master/examples/nextra-basic\n"}</code></pre><p>{"The quickest way to get set up and running is to use "}<a href="http://npmjs.com/package/create-next-app" parentName="p"><inlineCode parentName="a">{"create-next-app"}</inlineCode></a>{" with the example from the "}<inlineCode parentName="p">{"nextra-theme-mui-docs"}</inlineCode>{" Github repository."}</p><p>{"Run:"}</p><pre><code parentName="pre">{"yarn create next-app --example https://github.com/Janpot/mui-plus/tree/master/examples/nextra-basic\n"}</code></pre><p>{"Then follow the instructions to create and run the application."}</p><h2>{"Site Structure"}</h2><p>{"The pages hierarchy follows the way they are laid out but can be influenced in several ways. To change the order of pages in a folder, you can use frontmatter in the "}<inlineCode parentName="p">{"index.mdx"}</inlineCode>{" of that folder. You can eitehr just specify the page name, or an object with "}<inlineCode parentName="p">{"name"}</inlineCode>{"/"}<inlineCode parentName="p">{"title"}</inlineCode>{" properties."}</p><pre><code className="language-mdx" parentName="pre">{"---\ntitle: Introduction\norder:\n  - index\n  - name: components\n    title: Components\n  - name: component-api\n    title: Component Api\n  - name: more\n    title: More\n---\n"}</code></pre><h2>{"Built-in components"}</h2><h3><inlineCode parentName="h3">{"CodeExample"}</inlineCode></h3><p>{"Add Example code blocks with the "}<inlineCode parentName="p">{"CodeExample"}</inlineCode>{" component."}</p><p>{"You'll need to add webpack configuration to "}<inlineCode parentName="p">{"next.config.js"}</inlineCode>{"."}</p><pre><code className="language-tsx" parentName="pre">{"module.exports = withNextra({\n  webpack: (config) => {\n    config.module.rules = [\n      {\n        oneOf: [\n          {\n            resourceQuery: /raw/,\n            type: 'asset/source',\n          },\n          {\n            rules: config.module.rules,\n          },\n        ],\n      },\n    ];\n\n    return config;\n  },\n});\n"}</code></pre><p>{"Create some example code:"}</p><pre><code className="language-tsx" parentName="pre">{"// ./Example.tsx\nimport * as React from 'react';\nexport default function MyComponent() {\n  /// preview-start\n  return <div>Hello World!</div>;\n  /// preview-end\n}\n"}</code></pre><p>{"Then you can import it in your mdx files:"}</p><pre><code className="language-tsx" parentName="pre">{"// ./pages/myExamplePage.ndx\nimport CodeExample from 'nextra-theme-mui-docs/CodeExample';\n\nimport Example from './Example';\nimport srcExample from './Example?raw';\n\n<CodeExample src={srcExample}>\n  <Example />\n</CodeExample>;\n"}</code></pre><p>{"That will render:"}</p>{"\n"}{"\n"}<CodeExample src={srcExample} mdxType="CodeExample"><Example parentName="CodeExample" mdxType="Example" /></CodeExample><p>{"You can use doc comments to create source code previews. Use "}<inlineCode parentName="p">{"/// preview-start"}</inlineCode>{" to start and "}<inlineCode parentName="p">{"/// preview-end"}</inlineCode>{" to end a preview block. Inside jsx "}<inlineCode parentName="p">{"{/** preview-start */}"}</inlineCode>{" and "}<inlineCode parentName="p">{"{/** preview-end */}"}</inlineCode>{" will also work."}</p></MDXLayout>;
}
MDXContent.isMDXComponent = true;
export default MDXContent;
